import React from "react";
import {Modal} from "@mui/material";
import {isEqual} from "lodash";
import {useViewController} from "data/services/locator/locator_hook.service";
import {IModalsController} from "views/controllers/modals/modals.controller";
import {ModalType} from "data/enums";
import {observer} from "mobx-react";
import {Bindings} from "data/constants/bindings";
import {
	CloseBtn,
	ModalBody,
	ModalBox,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalText,
	ModalTitle,
} from "views/components/modals/common/common.component";
import {ReactComponent as IconChecked} from "assets/img/icon/icon-checked.svg";
import {ReactComponent as IconClose} from "assets/img/icon/close.svg";
import {PrimaryButton, SecondaryButton} from "views/components/style";

export const SavedModal: React.FC = observer(() => {
	const controller = useViewController<IModalsController>(Bindings.ModalsController);
	const {i18n, visibleModal, close} = controller;
	const isVisible = isEqual(visibleModal, ModalType.TEAM_SAVED);

	if (!isVisible) {
		return null;
	}

	const title = i18n.t("modal.saved.title", "YOU’RE IN!");
	const message = i18n.t(
		"modal.saved.description",
		"Great! Your team(s) are in and you are in the draw to win X prize"
	);

	return (
		<Modal open={isVisible} onClose={close}>
			<ModalBox>
				<ModalContent>
					<ModalHeader>
						<IconChecked />
					</ModalHeader>
					<ModalBody>
						<ModalTitle>{title}</ModalTitle>
						<ModalText>{message}</ModalText>
					</ModalBody>
					<CloseBtn onClick={close}>
						<IconClose />
					</CloseBtn>
					<ModalFooter>
						<PrimaryButton fullWidth onClick={close} variant="contained" size="large">
							{i18n.t("modal.saved.share_btn", "Share")}
						</PrimaryButton>
						<SecondaryButton
							onClick={close}
							fullWidth
							variant="contained"
							size="large"
							style={{maxWidth: "320px"}}>
							{i18n.t("modal.saved.load_btn", "Download team(s)")}
						</SecondaryButton>
					</ModalFooter>
				</ModalContent>
			</ModalBox>
		</Modal>
	);
});
